import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import { getItem } from 'store/localeStorage'
import './changeLanguage.scss'
export default function ChangeLanguage() {
   const dispatch = useDispatch()
   return (
      <div id='changeLanguage' className='flex column items-start'>
         {getItem('parcours') !== 'visiteur' && (
            <Link to='/accueil/'>
               <img src={`${process.env.PUBLIC_URL}/img/picto_salaries_-_2023.png`} alt='' />
            </Link>
         )}

         <div
            style={{ marginTop: '5px' }}
            onClick={() => {
               dispatch({ type: 'fr' })
            }}
         >
            <img src={`${process.env.PUBLIC_URL}/img/picto_francais_-_2023.png`} alt='' />
         </div>
         <div
            onClick={() => {
               dispatch({ type: 'en' })
            }}
         >
            <img src={`${process.env.PUBLIC_URL}/img/picto_anglais_-_2023.png`} alt='' />
         </div>
      </div>
   )
}
